import React, { Component } from 'react';
import moment               from 'moment';

import { Page }  from 'moovila-common';
import Masthead         from '../Masthead';

class RepeatTester extends Component {
  constructor(props) {
    super(props);
    this.state = {
      guid: '',
    }
    this.updateGUID = this.updateGUID.bind(this);
  }

  updateGUID(e) {
    this.setState({
      guid: e.target.value,
    });
  }

  render() {
    return (
      <div className='RepeatTester'>
        <Masthead title='Repeat Tester' icon='fa fa-refresh' />
        <Page>
          <section className='section'>
            <div className='row'>
              <div className='col-xs-6 half-gutter-r'>
                <button className='btn btn-default btn-block btn-md' onClick={() => this.props.getRepeats(this.state.guid)}>
                  Show all Repeats
                </button>
              </div>
              <div className='col-xs-6 half-gutter-r'>
                <button className='btn btn-default btn-block btn-md' onClick={() => this.props.getRepeats(this.state.guid, true)}>
                  Show Only Differences
                </button>
              </div>
            </div>
          </section>
          <div className='row'>
            <div className='col-xs-12 form-group'>
              <label className='text-primary'>Task GUID:</label>
              <input
                className='form-control dark-label'
                placeholder='Enter Task GUID Here'
                value={this.state.guid}
                onChange={this.updateGUID}
              />
            </div>
          </div>
          <section className='section'>
            <div className='row'>
              <div className='col-xs-6'>
                <h3 className='body-title'>
                  <span className='text-primary'>Client Repeats:</span>
                </h3>
                <div className='text-area-tall apiRequest-small-input' rows='20'>
                  { this.props.repeats.client.map((repeatDate, i) => <div key={i}>{ moment(repeatDate).format('M/D/YYYY, h:mm:ss A') }</div>) }
                </div>
              </div>
              <div className='col-xs-6'>
                <h3 className='body-title'>
                  <span className='text-primary'>Server Repeats:</span>
                </h3>
                <div className='text-area-tall apiRequest-small-input' rows='20'>
                  { this.props.repeats.server.map((repeatDate, i) => <div key={i}>{ moment(repeatDate).format('M/D/YYYY, h:mm:ss A') }</div>) }
                </div>
              </div>
            </div>
          </section>
        </Page>
      </div>
    );
  }
}

export default RepeatTester;



// WEBPACK FOOTER //
// ./src/components/Utilities/RepeatTester.js